// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__MwEz4","rowContainer":"Hero_rowContainer__txyaV","row":"Hero_row__3_Icm","header":"Hero_header__DT50D","desc":"Hero_desc__gLk4u"};